/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Priority_Updated_ToastInputs */



/**
* | output |
* | --- |
* | "Priority updated" |
*
* @param {Explorer_Info_Priority_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_priority_updated_toast = /** @type {((inputs?: Explorer_Info_Priority_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Priority_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Priority updated")
	if (locale === "de") return /** @type {LocalizedString} */ ("Priority updated")
	if (locale === "it") return /** @type {LocalizedString} */ ("Priority updated")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Priority updated")
	if (locale === "es") return /** @type {LocalizedString} */ ("Priority updated")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Priority updated")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Priority updated")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Priority updated")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Priority updated")
	return /** @type {LocalizedString} */ ("Priority updated")
});